import { Drawer, DrawerEditable } from './Drawer';

const DrawerContent = ({ position, contenteditable = false }) =>
  contenteditable ? DrawerEditable({ position }) : Drawer({ position });

export default DrawerContent;
